import { useTranslation } from 'react-i18next';

import { Subtitle1 } from '@myphx-engineering/phx-design-system';

import type { PricingCardElementProps } from '../../common/shared';
import { usePriceQualifier } from '../../common/use-price-qualifier';

export const SelfPayPricingCardLine2 = ({
    medication,
    patientPay,
    priceType,
}: Omit<PricingCardElementProps, 'hasIncentivePricing' | 'savings'>) => {
    const { t } = useTranslation('lilly');

    const priceQualifier = usePriceQualifier({
        medication,
        patientPay,
        priceType,
    });

    return (
        <Subtitle1>
            {t('fill.pricing.asLowAs', {
                price: patientPay,
                qualifier: priceQualifier?.text ?? '',
            })}
        </Subtitle1>
    );
};
